import { useViewportSize } from '@mantine/hooks';

const MOBILE_CHART_HEIGHT = 192;   // reference: h-48 = 12rem
const DESKTOP_CHART_HEIGHT = 224;  // reference: h-56 = 14rem
const MOBILE_BREAKPOINT = 991;

/**
 * Chart height matching reference design.
 * Mobile: fixed 192px (h-48). Desktop: fixed 224px (h-56).
 */
export function useChartHeight(): number {
  const { width } = useViewportSize();

  if (width > 0 && width <= MOBILE_BREAKPOINT) {
    return MOBILE_CHART_HEIGHT;
  }

  return DESKTOP_CHART_HEIGHT;
}
